(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const VIEW_KEY = "gymbabe:recently-viewed";
  const POP_CLOSE = "gymbabe:popular-closed";
  const POP_COUNT = "gymbabe:popular-count";

  function cartOpen() {
    const d = qs("[data-cart-drawer]");
    return d && (d.classList.contains("is-open") || d.hidden === false && d.classList.contains("is-open"));
  }
  function overlayBusy() {
    if (cartOpen()) return true;
    if (qs("[data-menu-drawer]:not([hidden])")?.classList.contains("is-open")) return true;
    if (qs("#shopify-pc-root, #shopify-section-cookie, .needsclick, #CybotCookiebotDialog")) {
      const cookie = qs("#CybotCookiebotDialog, .cc-window, [id*='cookie'][class*='visible']");
      if (cookie && cookie.offsetParent) return true;
    }
    return false;
  }

  /* Alle kleurswatches altijd zichtbaar */
  qsa("[data-swatches]").forEach((row) => {
    qsa("[data-swatch]", row).forEach((dot) => {
      dot.hidden = false;
    });
    qsa(".gb-swatches__more", row).forEach((more) => more.remove());
  });

  /* Filter dropdowns */
  qsa("[data-drop]").forEach((drop) => {
    const btn = qs("[data-drop-btn]", drop);
    const menu = qs("[data-drop-menu]", drop);
    if (!btn || !menu) return;
    btn.addEventListener("click", () => {
      const open = menu.hidden;
      qsa("[data-drop-menu]").forEach((m) => {
        m.hidden = true;
      });
      menu.hidden = !open;
    });
  });
  document.addEventListener("click", (e) => {
    if (!e.target.closest("[data-drop]")) {
      qsa("[data-drop-menu]").forEach((m) => {
        m.hidden = true;
      });
    }
  });
  qsa("[data-filter-submit]").forEach((el) => {
    el.addEventListener("change", () => el.closest("form")?.submit());
  });
  const filterSheet = qs("[data-filter-sheet]");
  const filterOverlay = qs("[data-filter-overlay]");
  qsa("[data-open-filter]").forEach((b) =>
    b.addEventListener("click", () => {
      if (filterSheet) filterSheet.hidden = false;
      if (filterOverlay) filterOverlay.hidden = false;
      document.body.style.overflow = "hidden";
    })
  );
  function closeFilter() {
    if (filterSheet) filterSheet.hidden = true;
    if (filterOverlay) filterOverlay.hidden = true;
    document.body.style.overflow = "";
  }
  qsa("[data-close-filter]").forEach((b) => b.addEventListener("click", closeFilter));
  if (filterOverlay) filterOverlay.addEventListener("click", closeFilter);

  /* PDP tabs */
  qsa("[data-tabs]").forEach((root) => {
    const tabs = qsa("[data-tab]", root);
    const panels = qsa("[data-tabpanel]", root);
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.classList.toggle("is-on", t === tab));
        panels.forEach((p) => {
          if (p.closest(".gb-acc")) return;
          p.classList.toggle("is-on", p.dataset.tabpanel === tab.dataset.tab);
        });
      });
    });
  });

  /* Recently viewed */
  const productJson = qs("[data-product-json]");
  if (productJson) {
    try {
      const p = JSON.parse(productJson.textContent);
      const list = JSON.parse(sessionStorage.getItem(VIEW_KEY) || "[]");
      const item = {
        title: p.title,
        url: window.location.pathname,
        image: p.featured_image || "",
      };
      const next = [item, ...list.filter((x) => x.url !== item.url)].slice(0, 8);
      sessionStorage.setItem(VIEW_KEY, JSON.stringify(next));
    } catch {
      /* ignore */
    }
  }


  /* 10% welkomstkorting popup */
  const welcome = qs("[data-welcome-popup]");
  if (welcome) {
    const key = "gymbabe:welcome-popup";
    const success = qs("[data-welcome-success]", welcome);
    const saved = Number(localStorage.getItem(key) || 0);
    const sevenDays = 7 * 24 * 60 * 60 * 1000;
    const delay = Number(welcome.dataset.delay || 6);

    function closeWelcome(permanent) {
      welcome.hidden = true;
      welcome.classList.remove("is-open");
      document.body.style.overflow = "";
      localStorage.setItem(key, String(Date.now()));
      if (permanent) localStorage.setItem(`${key}:subscribed`, "1");
    }

    qsa("[data-welcome-close]", welcome).forEach((btn) => {
      btn.addEventListener("click", () => closeWelcome(false));
    });

    if (success) {
      welcome.hidden = false;
      welcome.classList.add("is-open");
      document.body.style.overflow = "hidden";
      localStorage.setItem(`${key}:subscribed`, "1");
    } else if (!localStorage.getItem(`${key}:subscribed`) && (!saved || Date.now() - saved > sevenDays)) {
      setTimeout(() => {
        if (overlayBusy()) return;
        welcome.hidden = false;
        welcome.classList.add("is-open");
        document.body.style.overflow = "hidden";
      }, delay * 1000);
    }
  }

  /* Popular popup */
  const pop = qs("[data-popular-popup]");
  if (pop && !sessionStorage.getItem(POP_CLOSE)) {
    const mode = pop.dataset.mode;
    const delay = Number(pop.dataset.delay || 10) * 1000;
    const interval = Number(pop.dataset.interval || 28) * 1000;
    const max = Number(pop.dataset.max || 3);
    const duration = Number(pop.dataset.duration || 5) * 1000;
    const showThumb = pop.dataset.thumb !== "false";
    const catalog = (() => {
      try {
        return JSON.parse(qs("[data-popular-products]")?.textContent || "[]");
      } catch {
        return [];
      }
    })();
    const viewed = (() => {
      try {
        return JSON.parse(sessionStorage.getItem(VIEW_KEY) || "[]");
      } catch {
        return [];
      }
    })();
    const statuses = [
      ["GYMBABE FAVORITE", "Populaire keuze"],
      ["POPULAIR OP DIT MOMENT", "Veel bekeken door Gymbabes"],
      ["TRENDING", "Een favoriet binnen Gymbabe"],
    ];
    function pool() {
      if (mode === "real") return viewed;
      if (mode === "fallback") return catalog.length ? catalog : viewed;
      return [];
    }
    let shown = Number(sessionStorage.getItem(POP_COUNT) || 0);
    let idx = 0;
    function hide() {
      pop.hidden = true;
    }
    function show() {
      if (shown >= max || overlayBusy()) return;
      const items = pool();
      if (!items.length) return;
      const item = items[idx % items.length];
      idx += 1;
      const st = statuses[shown % statuses.length];
      qs("[data-popular-kicker]", pop).textContent = st[0];
      qs("[data-popular-status]", pop).textContent = st[1];
      qs("[data-popular-title]", pop).textContent = item.title || "";
      const link = qs("[data-popular-link]", pop);
      if (link) link.href = item.url || "#";
      const img = qs("[data-popular-img]", pop);
      if (img) {
        if (showThumb && item.image) {
          img.hidden = false;
          img.src = item.image;
        } else img.hidden = true;
      }
      pop.hidden = false;
      shown += 1;
      sessionStorage.setItem(POP_COUNT, String(shown));
      setTimeout(hide, duration);
    }
    qs("[data-popular-close]", pop)?.addEventListener("click", () => {
      hide();
      sessionStorage.setItem(POP_CLOSE, "1");
    });
    setTimeout(() => {
      show();
      const t = setInterval(() => {
        if (sessionStorage.getItem(POP_CLOSE) || shown >= max) {
          clearInterval(t);
          return;
        }
        show();
      }, interval);
    }, delay);
  }

  /* Card swatches + quick add */
  function cardVariants(card) {
    try {
      return JSON.parse(qs("[data-card-variants]", card)?.textContent || "[]");
    } catch {
      return [];
    }
  }
  function activeColor(card) {
    return qs("[data-swatch].is-active", card)?.getAttribute("title") || "";
  }
  function variantFor(card, size) {
    const colorIdx = card.dataset.colorIndex == null ? NaN : Number(card.dataset.colorIndex);
    const sizeIdx = card.dataset.sizeIndex == null ? NaN : Number(card.dataset.sizeIndex);
    const color = activeColor(card);
    const list = cardVariants(card);
    return (
      list.find((v) => {
        const colorOk = Number.isNaN(colorIdx) || !color || v.options[colorIdx] === color;
        const sizeOk = Number.isNaN(sizeIdx) || v.options[sizeIdx] === size;
        return colorOk && sizeOk;
      }) || list.find((v) => Number.isNaN(sizeIdx) || v.options[sizeIdx] === size)
    );
  }

  qsa("[data-product-card]").forEach((card) => {
    qsa("[data-swatch]", card).forEach((sw) => {
      sw.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const img = qs("[data-card-image]", card);
        if (img && sw.dataset.image) {
          img.src = sw.dataset.image;
          img.srcset = "";
        }
        qsa("[data-swatch]", card).forEach((s) => s.classList.toggle("is-active", s === sw));
      });
    });
  });

  document.addEventListener("click", (e) => {
    const open = e.target.closest("[data-quick-open]");
    if (open) {
      e.preventDefault();
      e.stopPropagation();
      const wrap = open.closest("[data-quick]");
      if (!wrap) return;
      open.hidden = true;
      const sizes = qs("[data-quick-sizes]", wrap);
      if (sizes) sizes.hidden = false;
      wrap.classList.add("is-open");
      return;
    }
    const addBtn = e.target.closest("[data-quick-add]");
    if (!addBtn) return;
    e.preventDefault();
    e.stopPropagation();
    const card = addBtn.closest("[data-product-card]");
    const size = addBtn.textContent.trim();
    const v = card ? variantFor(card, size) : null;
    const id = (v && v.id) || addBtn.dataset.id;
    if (!id) return;
    if (v && v.available === false) return;
    if (typeof window.gymbabeAddToCart === "function") {
      window.gymbabeAddToCart(id);
    }
  });

  /* Predictive search */
  const searchDialog = qs("[data-search-dialog]");
  const searchInput = searchDialog && qs("input[type=search]", searchDialog);
  if (searchInput) {
    let box = qs("[data-predictive]", searchDialog);
    if (!box) {
      box = document.createElement("div");
      box.className = "gb-predictive";
      box.setAttribute("data-predictive", "");
      searchDialog.appendChild(box);
    }
    let st;
    searchInput.addEventListener("input", () => {
      clearTimeout(st);
      const q = searchInput.value.trim();
      st = setTimeout(async () => {
        if (!q) {
          box.innerHTML = "";
          return;
        }
        const base = window.theme?.routes?.predictive_search_url || "/search/suggest";
        const url = `${base}${base.includes("?") ? "&" : "?"}q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
        try {
          const jsonUrl = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
          const data = await fetch(jsonUrl).then((r) => r.json());
          const products = data.resources?.results?.products || [];
          if (!products.length) {
            box.innerHTML = `<p class="muted">Niets gevonden.</p>`;
            return;
          }
          box.innerHTML = products
            .map(
              (p) =>
                `<a class="gb-predictive__hit" href="${p.url}"><img src="${p.image || ""}" alt=""><span>${p.title}<small>${p.price || ""}</small></span></a>`
            )
            .join("");
        } catch {
          /* keep form fallback */
        }
      }, 180);
    });
  }
})();
